import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import List from "./Ops.UserMessaging.List";
import Summary from "./Ops.UserMessaging.Summary";
import Edit from "./Ops.UserMessaging.Edit";
import Create from "./Ops.UserMessaging.Create";
import { groupAuth } from "app/utils/authGroups";

const hasWritePermission = groupAuth.hasAccessGroup(["Ops/UserMessaging"]);

const UserMessaging = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/user_messaging"
      render={() => <Redirect to="/snapscan/ops/user_messaging/list" />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/user_messaging/list"
      render={routerProps => <List {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/user_messaging/new"
      render={routerProps =>
        hasWritePermission ? (
          <Create {...{ ...props, ...routerProps }} />
        ) : (
          "Unauthorized"
        )
      }
    />
    <Route
      exact={true}
      path="/snapscan/ops/user_messaging/:id/summary"
      render={routerProps => <Summary {...{ ...props, ...routerProps }} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/user_messaging/:id/edit"
      render={routerProps =>
        hasWritePermission ? (
          <Edit {...{ ...props, ...routerProps }} />
        ) : (
          "Unauthorized"
        )
      }
    />
  </Switch>
);

export default UserMessaging;
